import '../../utils/Css/Style.css';
import React from 'react';
import CanvasJSReact from './jslib/canvasjs.react';
const DashboardRH = () => {
  const CanvasJSChart = CanvasJSReact.CanvasJSChart;
  //bar chart options
  const Barchartoptions = {

    title: {
      text: "Nombre de personnel par post",
      fontFamily: "Arial",
      fontSize: 15,
      fontWeight: "bold"
    },
    data: [{
      type: "column",
      dataPoints: [
        { label: "ingénieur", y: 10, color: "#000" },
        { label: "vendeur(se)", y: 15, color: "#333333" },
        { label: "stagiaire", y: 25, color: "#181818" },
        { label: "minuisier", y: 73, color: "#4F4F4F" },
        { label: "RH", y: 28, color: "#666666" }
      ]
    }]
  }
  const doughnutchartoptions = {
    title: {
      text: "Nombre de personnel par genre",
      fontFamily: "Arial",
      fontSize: 15,
      fontWeight: "bold"
    },
    data: [{
      type: "doughnut",
      dataPoints: [
        { label: "Homme", y: 50, color: "rgb(54, 162, 235)" },
        { label: "Femme", y: 20, color: "rgb(255, 99, 132)" },
      ]
    }]
  }
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <br />


      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div class="col-lg-3 col-6">
              <div class="small-box bg-dark" style={{ "height": "131px" }}>
                <div class="inner">
                  <h3>150</h3>
                  <p>Nombre d'employé</p>
                </div>
                <div class="icon">
                  <i class="fas fa-solid fa-users"></i>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-6">
              <div class="small-box bg-secondary" style={{ "height": "131px" }} >
                <div class="inner">
                  <h3>53</h3>

                  <p>Ordre de mission</p>
                </div>
                <div class="icon">
                  <i class="fas fa-solid fa-route"></i>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-6">
              <div class="small-box bg1" style={{ "height": "131px" }}>
                <div class="inner">
                  <h3>44</h3>
                  <p >Demande de congé en attente</p>
                </div>
                <div class="icon">

                  <i class="fas  fa-person"></i>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-6">
              <div class="small-box bg2" style={{ "height": "131px" }}>
                <div class="inner">
                  <h3>65</h3>
                  <p>Demande d'avance en attente</p>
                </div>
                <div class="icon">
                  <i class="fas fa-user-graduate"></i>
                </div>
              </div>
            </div>



            <div className="col-md-12  col-sm-12 col-lg-12">
              <div className="container">
                <div className="row">
                  {/* table des absents aujourd'hui */}
                  <div className="col-md-12 col-lg-6 col-sm-12">
                    <div class="card">
                      <div class="card-header border-transparent">
                        <h3 class="card-title">Absent aujourd'hui
                          <span class="badge bg-inverse-danger ms-2">5</span></h3>
                        <div class="card-tools">
                          <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fas fa-minus"></i>
                          </button>
                          <button type="button" class="btn btn-tool" data-card-widget="remove">
                            <i class="fas fa-times"></i>
                          </button>
                        </div>
                      </div>
                      <div class="card-body p-0">
                        <div class="table-responsive">
                          <table class="table m-0">
                            <thead>
                              <tr>
                                <th>Nom</th>
                                <th>Date de congé</th>
                                <th>Status</th>

                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>John doe</td>
                                <td>4 Sep 2019</td>
                                <td><span class="badge bg-inverse-danger">En attente</span></td>

                              </tr>
                              <tr>
                                <td>Martin Lewis</td>
                                <td>4 Sep 2019</td>
                                <td><span class="badge bg-inverse-danger">En attente</span></td>

                              </tr>
                              <tr>
                                <td>Martin Lewis</td>
                                <td>4 Sep 2019</td>
                                <td><span class="badge bg-inverse-danger">En attente</span></td>

                              </tr>
                              <tr>
                                <td>Martin Lewis</td>
                                <td>4 Sep 2019</td>
                                <td><span class="badge bg-inverse-danger">En attente</span></td>

                              </tr>
                              <tr>
                                <td>Martin Lewis</td>
                                <td>4 Sep 2019</td>
                                <td><span class="badge bg-inverse-danger">En attente</span></td>

                              </tr>
                              <tr>
                                <td>Martin Lewis</td>
                                <td>4 Sep 2019</td>
                                <td><span class="badge bg-inverse-success">Approuvé</span></td>

                              </tr>
                              <tr>
                                <td>Martin Lewis</td>
                                <td>4 Sep 2019</td>
                                <td><span class="badge bg-inverse-success">Approuvé</span></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="card-footer clearfix">
                        <a href="javascript:void(0)" class="btn btn-sm btn-secondary float-right">Afficher plus</a>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-12 col-sm-12">
                      <CanvasJSChart options={doughnutchartoptions} />
                    </div>
                  </div>

                  <div className="col-md-12 col-lg-6 col-sm-12">
                    {/* statistiques */}
                    <div class="card card-primary card-outline">
                      <div class="card-header">
                        <h3 class="card-title">
                          <i class="far fa-chart-bar"></i>
                          Statistique
                        </h3>
                      </div>
                      <div class="progress-group mx-2 ">
                        Present aujourd'hui
                        <span class="float-right"><b>160</b>/200</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-primaryy" style={{ "width": "80%" }}></div>
                        </div>
                      </div>

                      <div class="progress-group mx-2">
                        Nouveaux employé
                        <span class="float-right"><b>310</b>/400</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-dangerr" style={{ "width": "75%" }}></div>
                        </div>
                      </div>
                      <div class="progress-group mx-2">
                        <span class="progress-text">Employés payé</span>
                        <span class="float-right"><b>480</b>/800</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-successs" style={{ "width": "60%" }}></div>
                        </div>
                      </div>
                      <div class="progress-group mx-2">
                        Employés non payé
                        <span class="float-right"><b>250</b>/500</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-warningg" style={{ "width": "50%" }}></div>
                        </div>
                      </div>
                    </div>

                    {/* canvas bar chart */}
                    <div className="col-md-12 col-lg-12 col-sm-12">
                      <CanvasJSChart options={Barchartoptions} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div >
        </div >
      </div >
    </div >
  );
}

export default DashboardRH;